export function hasPermission(permission) {
    const permissions = JSON.parse(localStorage.getItem('userPermission')) || [];
    return permissions.includes(permission);
}

export function hasAnyPermission(requiredPermissions) {
    const permissions = JSON.parse(localStorage.getItem('userPermission')) || [];
    return requiredPermissions.some(permission => permissions.includes(permission));
}